module.exports = __webpack_public_path__ + "img/PT5200.306c8761.png";